<div id="review-id">
   <div class="mobile-view-only" style="text-align:center;">
      <header class="header-center-panal" style="text-align:center">
         <h3 style="font-size: 15px;">Review </h3>
      </header>
      <hr>
   </div>
   <div id="header">
      <div class="mobile-header-left header-left">
         <dl>
            <dd>
               <h3 style="font-size: 25px;"><b>{{reviewFormdata?.accountName}}</b></h3>
            </dd>
            <dd style="font-size: 14px;margin-top: -25px;">Account: <b>{{reviewFormdata?.accountNumber}}</b></dd>
         </dl>
      </div>
   </div>
   <br>

   <p-table #table [autoLayout]="true" [columns]="cols" [value]="invoiceValues" dataKey="documentId"
      (onPage)="onPage($event)" (onRowExpand)="onRowExpand()" (onRowCollapse)="onRowCollapse()"
      [expandedRowKeys]="expandedRows" selectionMode="multiple" [responsive]="true" styleClass="document-ptable"
      [(selection)]="selectedRows">
      <ng-template pTemplate="header" let-columns>
         <tr>
            <th class="td-width-3"></th>
            <th class="front-tableCheckbox table td-width-4"></th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width' : 'header-td-reduce-width'"><span>Document</span>
            </th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width' : 'header-td-reduce-width'"><span>Dates</span></th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width' : 'header-td-reduce-width'"><span>Amounts</span>
            </th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width text-call' : 'header-td-reduce-width text-call'">
               <span>Paid Online</span>
            </th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width' : 'header-td-reduce-width'"><span>Pay Amount</span>
            </th>

            <th *ngIf="shortPayHeader"
               [ngClass]="shortPayHeader ? 'header-td-extand-width-1 text-align-reason' : 'header-td-reduce-width-1 text-align-reason'">
               <span>Reason</span>
            </th>
            <th class="mobile-view-tableCheckbox table td-width-4 mobile-view-only"></th>
         </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-col let-expanded="expanded" let-columns="columns"
         let-rowIndex="rowIndex" style="margin-top: -12px;">
         <tr>
            <td class="td-width-3"> </td>
            <td class="web-view-only table td-width-4">
               <a href="#" [pRowToggler]="rowData">
                  <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
               </a>
            </td>
            <td class="test_documt" [ngClass]="shortPayHeader ? 'body-td-extand-width' : 'body-td-reduce-width'">
               <div class="mobile-doc mobile-view-only text-align-left">Document</div>
               <div class="mobile-device-class common-class">
                  <span>{{col.documentTypeName}}</span><br>
                  <span class="td-span-size"> {{col.invoiceNumber}} </span>
               </div>
            </td>
            <td [ngClass]="shortPayHeader ? 'body-td-extand-width' : 'body-td-reduce-width'">
               <div class="mobile-doc mobile-view-only text-align-left">Due Date</div>
               <div class="common-class mobile-device-class">
                  <span class="web-view-only">Due Date<br></span>
                  <span class="td-span-size"> {{checkDateFormate(col.dueDate)}} </span>
               </div>
            </td>
            <td [ngClass]="shortPayHeader ? 'body-td-extand-width' : 'body-td-reduce-width'"
               class="web-view-only opening-balance-common "><span
                  class="span-font-size span-color text-align-left">Open Balance </span>
               <br><span class="td-span-size">{{formatNumber(col.openBalance)}}</span>
            </td>
            <td [ngClass]="shortPayHeader ? 'body-td-extand-width text-call' : 'body-td-reduce-width text-call'"
               class="web-view-only paid-amount ">
               <span class="span-font-size span-color text-align-left">{{col.label}} </span>
               <span class="td-span-size"> {{formatNumber(col.paidOnline)}}</span>
            </td>
            <!-- {{col.paidOnline}} -->
            <td [ngClass]="shortPayHeader ? 'body-td-extand-width' : 'body-td-reduce-width'">
               <div class="mobile-doc mobile-view-only text-align-left">Pay Amount</div>
               <div class="common-class">
                  <span class="td-span-size"> {{formatNumber(col.payAmount)}}</span>

               </div>

            </td>

            <td *ngIf="col.showPay" [ngClass]="shortPayHeader ? 'body-td-extand-width-1' : 'body-td-reduce-width-1'">
               <div class="mobile-doc mobile-view-only text-align-left">Reason</div>
               <span *ngIf="col.shortPayreason != 'Others'" class="td-span-size shortPay-label">
                  {{col.shortPayreason}}</span>
               <span *ngIf="col.shortPayreason === 'Others'" class="td-span-size shortPay-label"
                  tooltip="{{col.shortPayText}}" placement="bottom" delay="500">
                  {{col.ShortPayTextDetails}}
               </span>

            </td>
            <td *ngIf="(shortPayHeader) && (!col.showPay)"> </td>
            <td class="td-see-more mobile-view-only" *ngIf="!expanded">
               <a href="#" [pRowToggler]="rowData">
                  <span class="span-font-size" *ngIf="!expanded"> See More</span>
                  <i *ngIf="!expanded" class="fa fa-fw fa-chevron-circle-down icon-align"></i>
               </a>
            </td>
         </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
         <tr>
            <td [attr.colspan]="columns.length">
               No records found
            </td>
         </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" let-rowIndex="rowIndex">
         <tr class="mobile-more_details-background-color other-more-details-background-color">
            <td [attr.colspan]="colLength" class="mobile-more_details-td other-more-details-td">
               <div class="mobile-more_shortPayHide p-grid p-fluid other-more_shortPayShow'">
                  <div class="more_shortPayShow">
                     <div class="p-col-12">
                        <div class="web-view-only">
                           <div class="p-grid">
                              <div [ngClass]="shortPayHeader ? 'p-col-1 more-info-1' : 'p-col-1 more-info'">
                                 More <br>Details
                              </div>
                              <div [ngClass]="shortPayHeader ? 'p-col-2 align-line-1' : 'p-col-2 align-line'">
                                 <dl *ngIf="rowData.poNumber || rowData.jobNumber || rowData.projectNumber ">
                                    <div *ngIf="rowData.poNumber">
                                       <dt>PO Number </dt>
                                       <dd>{{rowData.poNumber}}</dd>
                                    </div>
                                    <div *ngIf="rowData.jobNumber">
                                       <dt>Job Number</dt>
                                       <dd>{{rowData.jobNumber}}</dd>
                                    </div>
                                    <div *ngIf="rowData.projectNumber">
                                       <dt>Project Number</dt>
                                       <dd>{{rowData.projectNumber}}</dd>
                                    </div>
                                 </dl>
                              </div>
                              <div [ngClass]="shortPayHeader ? 'p-col-2 align-line-1' : 'p-col-2 align-line'">
                                 <dl *ngIf="rowData.discountDate || rowData.billDate">
                                    <div *ngIf="rowData.discountDate.trim()">
                                       <dt>Discount Date</dt>
                                       <dd>{{checkDateFormate(rowData.discountDate)}}</dd>
                                       <!-- <dd>{{rowIndex.discountDate}}</dd> -->
                                    </div>
                                    <div *ngIf="rowData.billDate">
                                       <dt>Bill Date</dt>
                                       <dd>{{checkDateFormate(rowData.billDate)}}</dd>
                                       <!-- <dd>{{rowIndex.billDate}}</dd> -->
                                       <dt></dt>
                                       <dd></dd>
                                    </div>
                                 </dl>
                              </div>
                              <div [ngClass]="shortPayHeader ? 'p-col-2 align-line-1' : 'p-col-2 align-line'">
                                 <dl *ngIf="rowData.discountAmount || rowData.totalDue">
                                    <div *ngIf="rowData.discountAmount" >
                                       <dt>Discount Amount</dt>
                                       <dd class="span-float-align">{{ formatNumber(rowData.discountAmount) }}</dd>
                                    </div>
                                    <div *ngIf="rowData.totalDue" >
                                       <dt>Bill Amount</dt>
                                       <dd class="span-float-align">{{ formatNumber(rowData.totalDue )}}</dd>
                                       <dt></dt>
                                       <dd></dd>
                                    </div>
                                 </dl>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="mobile-more-info mobile-view-only">
                        <div class="text-align-line-height">
                           <div *ngIf="rowData.poNumber">
                              <dt class="text-align-left">PO</dt>
                              <dd class="text-align-right">{{rowData.poNumber}}</dd>
                              <br>
                           </div>
                           <div *ngIf="rowData.billDate">
                              <dt class="text-align-left">Bill Date</dt>
                              <dd class="text-align-right">{{checkDateFormate(rowData.billDate)}}</dd>
                              <br>
                           </div>
                           <div *ngIf="rowData.totalDue">
                              <dt class="text-align-left">Bill Amount</dt>
                              <dd class="text-align-right">{{ formatNumber(rowData.totalDue )}}</dd>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </td>
            <td class=" mobile-view-only mobile-more-info td-see-more">
               <a href="#" [pRowToggler]="rowData">
                  <span class="span-font-size"> See Less</span>
                  <i class="fa fa-fw fa-chevron-circle-up icon-align"></i>
               </a>
            </td>

         </tr>
      </ng-template>
   </p-table>
   <br>
   Total Document(s): <span>{{ reviewFormdata?.totalDocument }}</span>
   <hr>
   <aur-grid>
      <aur-grid-area colspan="2">
         <b>Payment Date: </b><span>{{ reviewFormdata?.paymentDate }}</span>
         <br>
         <b>Payment Method: </b><span class="editmaterial" (click)="PreviousPage()">edit</span>
         <aur-grid>
            <aur-grid-area class="creditCardDetailsl">
               <dl>
                  <dt>Name:</dt>
                  <dd><span 
                     tooltip="{{reviewFormdata?.name}}" placement="bottom" delay="500">
                     {{reviewFormdata?.shortName}}
                  </span> </dd>
               </dl>
            </aur-grid-area>
            <aur-grid-area>
               <dl>
                  <dt>Payment Type:</dt>
                  <dd>{{reviewFormdata?.paymentType}}</dd>
               </dl>
            </aur-grid-area>
            <aur-grid-area>
               <dl>
                  <dt>Account Type:</dt>
                  <dd>{{reviewFormdata?.accountType}}</dd>
               </dl>
            </aur-grid-area>
         </aur-grid>
      </aur-grid-area>
      <aur-grid-area colspan="2">

         <aur-grid-area>
            <aur-card>
               <div *ngIf="isConvenienceLableShow">
                  <b>Subtotal: </b><span class="convenienceright">{{ formatNumber(reviewFormdata?.subTotal)
                     }}</span><br>
                  <b [innerHtml]="_customConvenienceFeeLabel"></b><span class="convenienceright">{{
                     formatNumber(convenienceFeeAmount) }}</span>
                  <br>
                  <div *ngIf="isCustomConvenienceLableShow">
                     <aur-notice severity="warning">
                        <div [innerHtml]="_customConvenienceCC"></div>
                     </aur-notice>
                  </div>
                  <hr>
               </div>
               <b>
                  <div id="reviewcurrencyType{{currencyVal}}"> {{currencyType}}Total Amount:
                     <span class="convenienceright">{{ formatNumber(reviewFormdata?.totalAmount) }}</span>
                  </div>
               </b>
            </aur-card>
            <br>

         </aur-grid-area>
      </aur-grid-area>
   </aur-grid>
   <aur-grid>
      <aur-grid-area colspan="1"></aur-grid-area>
      <aur-grid-area colspan="3">
         <aur-notice severity="info" title="Agreement">
            <p-checkbox [(ngModel)]="agreement" ngDefaultControl
               label="I authorize Billtrust to electronically debit/charge my account (and, if necessary, electronically credit my account to correct erroneous debits as indicated on the input form above). I understand the payment will be debited from the account in 24-48 hours from the time of authorization and there is no revocation."
               binary="true" class="aggrement"></p-checkbox>
         </aur-notice>
      </aur-grid-area>
   </aur-grid>
   <br>
   <aur-grid-area class="payment-footer payment-footer-panel" *ngIf="invoiceValues?.length">
      <footer class="footeralign">
         <div class="text-align-left text-padding btn-padding">
            <button class="mobile-btn-view" aur-button type="submit" id="prevBtn" (click)="PreviousPage()">Previous
               step</button>
         </div>
         <div class="text-align-right text-padding ">
            <button class="mobile-btn-view" aur-button type="submit" (click)="makepayment()">Make Payment</button>
         </div>
      </footer>
   </aur-grid-area>
</div>